module.exports = __webpack_public_path__ + "static/media/phone-icon-footer.8aa221c8.svg";